export default "__VITE_ASSET__44d57eac__"